// extracted by mini-css-extract-plugin
module.exports = {"container":"w_RmATiJ1Zkxhs5gX0vrv"};